cafm.prop = {
    init: function (e) {

        cafm.setCurrentModule(cafm.enums.CAFMModuleEnum.Property);

        cafm.nav.router = new cafm.router.Router({
            pathName: window.location.pathname,
            routes: cafm.prop.nav.routes,
            processOnInit: true,
            cache: true,
            routeKey: e.route ? e.route.routeKey : null,
            routeArgs: e.route ? e.route.routeArgs : null,
            onRouteChange: function (router) {

                cafm.hi.hideHierarchySearchButton();
            }
        });

        cafm.handlers.set('cafm.search', cafm.prop.topLevelSearch);
    },
    nav: {
        routes: {
            PropertyBuildingSearch: {
                path: 'buildings',
                handler: function () {
                    cafm.prop.nav.showPropertySearch('Buildings');
                }
            },
            PropertyFloorSearch: {
                path: 'floors',
                handler: function () {
                    cafm.prop.nav.showPropertySearch('Floors');
                }
            },
            PropertyZoneSearch: {
                path: 'zones',
                handler: function () {
                    cafm.prop.nav.showPropertySearch('Zones');
                }
            },
            PropertySpaceSearch: {
                path: 'spaces',
                handler: function () {
                    cafm.prop.nav.showPropertySearch('Spaces');
                }
            },
            PropertyNewSearch: {
                path: 'newSearch/{value}',
                noCache: true,
                handler: function (e) {
                    cafm.prop.nav.showSelectNewSearchType(e.args.value);
                }
            },
            PropertySavedSearch: {
                path: 'savedSearch/{value}',
                handler: function (e) {
                    cafm.prop.nav.showSavedSearch(e.args);
                }
            },
            PropertyQuickSearch: {
                path: 'search/{type}/{query}',
                handler: function (e) {
                    
                    cafm.prop.nav.showQuickSearch(e.args);
                }
            },
            PropertyEditBuilding: {
                path: 'viewBuilding/{id}',
                handler: function (e) {
                    e.args.type = cafm.enums.LocalityTypeData.Building;
                    cafm.prop.nav.showLocality(e.args);
                },
                fixedScrollbar: true
            },
            PropertyEditFloor: {
                path: 'viewFloor/{id}',
                handler: function (e) {
                    e.args.type = cafm.enums.LocalityTypeData.Floor;
                    cafm.prop.nav.showLocality(e.args);
                },
                fixedScrollbar: true
            },
            PropertyEditZone: {
                path: 'viewZone/{id}',
                handler: function (e) {
                    e.args.type = cafm.enums.LocalityTypeData.Zone;
                    cafm.prop.nav.showLocality(e.args);
                },
                fixedScrollbar: true
            },
            PropertyEditSpace: {
                path: 'viewSpace/{id}',
                handler: function (e) {
                    e.args.type = cafm.enums.LocalityTypeData.Space;
                    cafm.prop.nav.showLocality(e.args);
                },
                fixedScrollbar: true
            },
            PropertyEditRoom: {
                path: 'viewRoom/{id}',
                handler: function (e) {
                    e.args.type = cafm.enums.LocalityTypeData.Room;
                    cafm.prop.nav.showLocality(e.args);
                },
                fixedScrollbar: true
            },
            PropertyEditWorkgroup: {
                path: 'viewWorkgroup/{id}',
                handler: function (e) {
                    e.args.type = cafm.enums.LocalityTypeData.WorkGroup;
                    cafm.prop.nav.showLocality(e.args);
                },
                fixedScrollbar: true
            },
            PropertyEditTenure: {
                path: 'tenure/{id}',
                handler: function (e) {
                    cafm.prop.nav.showTenure(e.args);
                },
                fixedScrollbar: true
            },
            PropertyEditAsbestos: {
                path: 'asbestos/{localityId}/{id}',
                handler: function (e) {
                    cafm.prop.nav.showAsbestos(e.args);
                },
                fixedScrollbar: true
            }
        },
        showPropertySearch: function (view) {

            if (isMobile) cafm.url.set();

            cafm.filters.registerOnCriteriaReset(cafm.prop.onSearchCriteriaReset);

            cafm.views.main({
                url: cafm.url.get('Property/{0}'.format(view))
            });
        },
        showSelectNewSearchType: function (searchId) {

            cafm.prop._newSearchId = searchId;

            cafm.views.openActionWindow({
                url: cafm.url.get('Property/SelectNewSearchType'),
                method: 'GET',
                isForm: true,
                initialText: cafm.res.str.TextPreparingForm,
                winOptions: {
                    title: cafm.res.str.TitleSelectSearchType,
                    height: '100px'
                }
            });
        },
        showNewSearch: function (localityType) {

            cafm.views.main({
                url: cafm.url.get('Property/NewSearch/{0}/{1}'.format(localityType, cafm.prop._newSearchId))
            });
            cafm.views.closeActionWindow();
        },
        showSavedSearch: function (e) {

            cafm.filters.registerOnCriteriaReset(cafm.prop.onSearchCriteriaReset);
            cafm.hi.registerOnChange(cafm.prop.onHierarchyLocalityChanged);

            cafm.views.main({
                url: cafm.url.get('Property/SavedSearch/{0}'.format(e.value))
            });
        },
        showQuickSearch: function (args) {

            var q = args.query;

            if (!cafm.util.hasStringVal(args.type) || !cafm.util.hasStringVal(args.query)) {

                cafm.views.mainView().showMessage({

                    type: cafm.enums.MessageType.Error,
                    title: 'Search phrase or search type not provided'
                });

                return;
            }
            // workaround - replace any starting * as that doesn't route
            else if (q.startsWith('_*_')) {

                q = q.replace('_*_', '*');
            }

            cafm.views.main({
                url: cafm.url.get('Property/{0}?t={1}&q={2}'.format('Search', args.type, encodeURIComponent(q)))
            });
        },
        showLocality: function (args) {

            cafm.filters.deregisterOnCriteriaChanged();
            cafm.hi.deregisterOnChange();

            var locUrl = 'Property/Edit{0}/{1}'.format(cafm.enums.getEnumKey(cafm.enums.LocalityTypeData, args.type), args.id);
            cafm.views.main({
                url: cafm.url.get(locUrl),
                isForm: true, // treat as form so toolbar is setup!
                onLoad: function () {
                    cafm.prop.onLocalityLoaded(args.type);
                }
            });
        },
        navigateLocality: function (args) {

            var navKey = 'PropertyEdit' + cafm.enums.getEnumKey(cafm.enums.LocalityTypeData, args.type);

            // set a timeout to allow quick navigation through hierarchy
            // otherwise some events don't seem to be setup properly
            setTimeout(function () {
                cafm.nav.router.navigate(cafm.enums.Navigatable[navKey], args);
            }, 1000);
        },
        showTenure: function (args) {

            cafm.filters.deregisterOnCriteriaChanged();
            cafm.hi.deregisterOnChange();

            cafm.views.main({
                url: cafm.url.get('Property/EditTenure/{0}'.format(args.id)),
                isForm: true,
                onLoad: cafm.prop.onTenureLoaded
            });
        },
        showTenurePage: function (id) {

            window.location = cafm.url.get(cafm.res.consts.Url_PropertyTenure.format(id));
        },
        showAsbestos: function (args) {

            cafm.filters.deregisterOnCriteriaChanged();
            cafm.hi.deregisterOnChange();

            cafm.views.main({
                url: cafm.url.get('Property/EditAsbestos/{0}/{1}'.format(args.id, args.localityId)),
                isForm: true,
                onLoad: cafm.prop.onAsbestosLoaded
            });
        },
        showAsbestosPage: function (id, localityId) {

            window.location = cafm.url.get(cafm.res.consts.Url_PropertyAsbestos.format(id, localityId));
        }
    },
    onBuildingDataRetrieved: function (data, element) {

        if ((cafm.web.funcs.isTopSearch() || element.data('Searching')) && data.length == 1) {
            
            if (!cafm.filters.getViewModel().VisibleColumnsChanged) {

                cafm.nav.router.navigate(cafm.enums.Navigatable.PropertyEditBuilding, {
                    id: data[0].ID
                });
            }
        }

        data.forEach(function (dataItem) {

            var fName = cafm.res.consts.FieldName_IsPrimarySite;
            var v = dataItem[fName];
            dataItem[fName] = v ? cafm.res.str.TextYes : cafm.res.str.TextNo;
        });
    },
    onFloorDataRetrieved: function (data, element) {

        if ((cafm.web.funcs.isTopSearch() || element.data('Searching')) && data.length == 1) {

            cafm.nav.router.navigate(cafm.enums.Navigatable.PropertyEditFloor, {
                id: data[0].ID
            });
        }
    },
    onZoneDataRetrieved: function (data, element) {

        if ((cafm.web.funcs.isTopSearch() || element.data('Searching')) && data.length == 1) {

            cafm.nav.router.navigate(cafm.enums.Navigatable.PropertyEditZone, {
                id: data[0].ID
            });
        }
    },
    onSpaceDataRetrieved: function (data, element) {

        if ((cafm.web.funcs.isTopSearch() || element.data('Searching')) && data.length == 1) {

            cafm.nav.router.navigate(cafm.enums.Navigatable.PropertyEditSpace, {
                id: data[0].ID
            });
        }
    },
    onBuildingSelected: function (e, dataItem) {

        var id = dataItem[0].get('ID');
        cafm.nav.router.navigate(cafm.enums.Navigatable.PropertyEditBuilding, {
            id: id
        });
    },
    onFloorSelected: function (e, dataItem) {

        var id = dataItem[0].get('ID');
        cafm.nav.router.navigate(cafm.enums.Navigatable.PropertyEditFloor, {
            id: id
        });
    },
    onZoneSelected: function (e, dataItem) {

        var id = dataItem[0].get('ID');
        cafm.nav.router.navigate(cafm.enums.Navigatable.PropertyEditZone, {
            id: id
        });
    },
    onSpaceSelected: function (e, dataItem) {

        var id = dataItem[0].get('ID');
        cafm.nav.router.navigate(cafm.enums.Navigatable.PropertyEditSpace, {
            id: id
        });
    },
    onHierarchyLocalityChanged: function (loc) {

        var lt = loc.get('LocalityType');
        if (cafm.hi.casc.getAllowedLocalityDepth() == lt) {

            var navEnum;
            switch (lt) {
                case cafm.enums.LocalityTypeData.Building:
                    navEnum = cafm.enums.Navigatable.PropertyEditBuilding;
                    break;
                case cafm.enums.LocalityTypeData.Floor:
                    navEnum = cafm.enums.Navigatable.PropertyEditFloor;
                    break;
                case cafm.enums.LocalityTypeData.Zone:
                    navEnum = cafm.enums.Navigatable.PropertyEditZone;
                    break;
                case cafm.enums.LocalityTypeData.Space:
                    navEnum = cafm.enums.Navigatable.PropertyEditSpace;
                    break;
                case cafm.enums.LocalityTypeData.Room:
                    navEnum = cafm.enums.Navigatable.PropertyEditRoom;
                    break;
                case cafm.enums.LocalityTypeData.WorkGroup:
                    navEnum = cafm.enums.Navigatable.PropertyEditWorkgroup;
                    break;
            }
            if (navEnum) {
                cafm.nav.router.navigate(navEnum, {
                    id: loc.get('LocalityID')
                });
                return;
            }
        }

        var criteria = cafm.filters.getViewModel();
        var typeName = cafm.enums.getEnumKey(cafm.enums.LocalityTypeData, loc.get('LocalityType'));
        if (criteria.get('LocalityID') != loc.get('LocalityID')) {

            criteria.set('LocalityTypeName', typeName);
            cafm.hi.setHierarchyFilterValues(loc.get('LocalityID'), loc.get(typeName));
        }
    },
    onSearchCriteriaReset: function (criteria) {

        var currentLoc = cafm.hi.getCurrentLocality();
        if (currentLoc.get('LocalityID') != criteria.get('LocalityID')) {

            cafm.hi.updateLocality(currentLoc, criteria.get('LocalityID'), criteria.get('LocalityDescription'), criteria.get('LocalityTypeName'));
            cafm.hi.setCurrentLocality({
                locality: currentLoc
            });
        }
    },
    onLocalityLoaded: function (localityType) {

        var mainForm = cafm.views.getMainForm();
        var locality = mainForm.getViewModel();

        cafm.handlers.set('cafm.forms.afterFormTabChanged', contentElement => {
            // setup toolbar
            $('.cTb', contentElement).setupToolbar();
            // check for removeable items
            cafm.forms.checkForRemovables();
        });

        cafm.prop.bindLocalityViewModelChangedEvent(mainForm);

        cafm.prop.registerHierarchyChangeEvent();

        cafm.forms.placeMainFormToolbar();

        var historyType = cafm.enums.HistoryItemType[cafm.enums.getEnumKey(cafm.enums.LocalityTypeData, localityType)];
        cafm.nav.router.addRouteToHistory({
            itemKey: locality.ID,
            itemTitle:locality.Description,
            itemType: historyType
        });

        // format barcode link
        let barcodeElement = $(".cfRoValSpan[name=\"Barcode\"]");
        cafm.scanner.formatBarcodeLink(barcodeElement);
    },
    onTenureLoaded: function () {

        cafm.handlers.set('cafm.forms.afterFormTabChanged', cafm.forms.checkForRemovables);

        $('#{0}'.format(cafm.res.consts.ElementId_FormWidget)).data('kendoTabStrip').select(0);

        cafm.prop.registerHierarchyChangeEvent();

        var tenure = cafm.views.getMainFormViewModel();
        cafm.nav.router.addRouteToHistory({
            itemKey: tenure.ID,
            itemTitle: tenure.Description,
            itemType: cafm.enums.HistoryItemType.Tenure
        });
    },
    onAsbestosLoaded: function () {

        cafm.handlers.set('cafm.forms.afterFormTabChanged', cafm.forms.checkForRemovables);

        $('#{0}'.format(cafm.res.consts.ElementId_FormWidget)).data('kendoTabStrip').select(0);

        cafm.prop.registerHierarchyChangeEvent();

        var asbestos = cafm.views.getMainFormViewModel();
        cafm.nav.router.addRouteToHistory({
            itemKey: asbestos.ID,
            itemTitle: asbestos.Description,
            itemType: cafm.enums.HistoryItemType.AsbestosElement
        });
    },
    registerHierarchyChangeEvent: function () {

        cafm.hi.registerOnChange(function (e) {

            if (cafm.nav.router.lastNavArgs != e.LocalityID) {

                cafm.prop.nav.navigateLocality({
                    id: e.LocalityID,
                    type: e.LocalityType
                });
            }
        });
    },
    bindLocalityViewModelChangedEvent: function (mainForm) {

        mainForm.getViewModel().bind('change', cafm.prop.localityViewModelChanged);
    },
    onPropertyTreeSelect: function (e) {

        switch (e.type) {

            case cafm.enums.TreeViewItemType.FormCategory:

                cafm.prop.switchFormPanel(e);
                break;

            case cafm.enums.TreeViewItemType.FormAction:

                cafm.prop.performFormAction(e);
                break;
        }
    },
    switchFormPanel: function (e) {

        var toCollapse = $('> [data-expanded]', e.item.parent());
        e.tree.collapse(toCollapse);
        e.tree.expand(e.item);

        var key = e.item.data('key');
        if (key != cafm.res.consts.DataKey_PropertyRoles) {
            $('#{0} .k-tabstrip-items [data-key="{1}"]'.format(cafm.res.consts.ElementId_FormWidget, key)).click();
        }
    },
    performFormAction: function (e) {

        var key = e.item.data('key');
        var actionEnum = cafm.enums.LocalityFormAction[key];

        switch (actionEnum) {

            case cafm.enums.LocalityFormAction.AddNote:

                cafm.views.openChildActionWindow(e);
                break;

            case cafm.enums.LocalityFormAction.RemoveSelected:

                var listWrappers = $('#{0} .k-content.k-state-active .cLvWrap'.format(cafm.res.consts.ElementId_MainForm));
                listWrappers.each(function (i, el) {

                    var selected = $(el).getSelectedItemUids();
                    if (selected && selected.length) {
                        $('.cTb [data-key="Remove"]', el).click();
                    }
                });
                break;

            case cafm.enums.LocalityFormAction.UploadNewDocument:
            case cafm.enums.LocalityFormAction.AddExistingDocument:

                cafm.views.openActionWindow({
                    url: cafm.url.get(e.item.data('action')),
                    isForm: true,
                    initialText: cafm.res.str.TextPreparingForm,
                    winOptions: {
                        title: $('.k-in', e.item).text(),
                        width: cafm.util.viewPortWidth(60),
                        height: cafm.util.viewPortHeight(80)
                    }
                });

                break;
        }


    },
    localityViewModelChanged: function (e) {

        if (e.field == 'MeasurementUnits' || e.field == 'MeasurementUnits2') {

            var vm = e.sender.source;
            cafm.actions.execute({
                url: cafm.url.get('Property/SetAreaMeasurementUnits'),
                elementId: cafm.res.consts.ElementId_MainForm,
                loaderSelector: '#{0}'.format(cafm.res.consts.ElementId_MainForm),
                values: {
                    LocalityId: vm.get('ID'),
                    MeasurementUnits: vm.get(e.field)
                },
                statusCodeFuncs: {
                    200: function (res) {

                        cafm.user.prefs.MeasurementUnits = res.MeasurementUnits;
                        cafm.user.prefs.AreaMaskOuputFormat = res.AreaMaskOuputFormat;

                        var mainForm = cafm.views.getMainForm();
                        mainForm.bindViewModel({
                            viewModel: res
                        }).prepareForm();

                        cafm.prop.bindLocalityViewModelChangedEvent(mainForm);

                    }
                }
            });
        }
    },
    buildingListItemSelected: function (e) {

        cafm.nav.router.navigate(cafm.enums.Navigatable.PropertyEditBuilding, {
            id: e.sender.getSelected().get('ID')
        });
    },
    onHazardsRetrieved: function (e) {

        e.forEach(function (haz) {

            haz.LastModifiedDate = cafm.util.ensureDate(haz.LastModifiedDate);
        });
    },
    onAsbestosRetrieved: function (e) {

        e.forEach(function (asb) {

            asb.SurveyDate = cafm.util.ensureDate(asb.SurveyDate);
            asb.ReviewDate = cafm.util.ensureDate(asb.ReviewDate);
        });
    },
    onAsbestosSelected: function (e) {

        var locality = cafm.views.getMainFormViewModel();
        var asbestos = e.sender.getSelected();

        cafm.nav.router.navigate(cafm.enums.Navigatable.PropertyEditAsbestos, {
            localityId: locality.get('ID'),
            id: asbestos.get('ID')
        });
    },
    onTenuresRetrieved: function (e) {

        e.forEach(function (ten) {

            ten.StartDate = cafm.util.ensureDate(ten.StartDate);
            ten.EndDate = cafm.util.ensureDate(ten.EndDate);
        });
    },
    onWorkOrderDataBound: function (e) {
                
        // loop each item and apply life cycle status formatting
        $('.cLvIt', e.sender.element).each(function (i, item) {

            item = $(item);

            var lcsStatus = item.find('.lcsStatus'),
                lcs = lcsStatus.data('value');

            lcsStatus.replaceWith($(cafm.hd.formatLcs(lcs)));
        });
    },
    onProjectsRetrieved: function (e) {

        e.forEach(function (proj) {

            proj.StartDate = cafm.util.ensureDate(proj.StartDate);
        });
    },
    onProjectSelected: function (e) {

        var project = e.sender.getSelected();

        cafm.views.openActionWindow({
            url: cafm.url.get('Property/Project/{0}'.format(project.ID)),
            winTitle: project.Description,
            initialText: cafm.res.str.TextLoadingProject,
            winOptions: {
                height: 360
            }
        });
    },
    onTenureSelected: function (e) {

        var tenure = e.sender.getSelected();

        cafm.nav.router.navigate(cafm.enums.Navigatable.PropertyEditTenure, {
            id: tenure.get('ID')
        });
    },
    onRentSelected: function (e) {

        var tenure = cafm.views.getMainFormViewModel();
        var rent = e.sender.getSelected();

        cafm.views.openActionWindow({
            url: cafm.url.get('Property/TenureRentReviews'),
            method: 'POST',
            values: cafm.util.createParentChildId(tenure.get('ID'), rent.get('ID')),
            winTitle: rent.get('Description'),
            initialText: cafm.res.str.TextLoadingRentReviews,
            winOptions: {
                height: 300
            }
        });
    },
    editLocalityToolbar: {

        print: function (e) {
            /// <summary>Print handler</summary>
            /// <param name="e" type="Object">The dom event</param>

            var building = cafm.views.getMainFormViewModel();
            window.location = cafm.url.api('Building/PrintBuilding?id={0}'.format(building.get('ID')));
        },
        reportdataissue: function (e) {

            var locality = cafm.views.getMainFormViewModel(),
                infoErrorMsg = cafm.util.getReference(cafm.res.consts.ObjectPath_PropertyInfoErrorMsg),
                mailRecipient = infoErrorMsg.ToAddress,
                mailSubject = infoErrorMsg.Subject,
                mailBody = infoErrorMsg.MessageBody;

            mailSubject = mailSubject.replace('{PropertyDescription}', locality.get('Description'));
            mailBody = mailBody.replace('{PropertyDescription}', locality.get('Description'));
            mailBody = mailBody.replace('{PropertyReference}', locality.get('Reference'));
            mailBody = mailBody.replace('{PropertyLink}', cafm.url.abs(cafm.res.consts.Url_PropertyBuilding.format(locality.get('ID'))));

            cafm.util.mailTo({
                ToAddress: mailRecipient,
                Subject: mailSubject,
                MessageBody: mailBody
            });
        }
    },
    newSearch: {

        building: function (e) {

            cafm.prop.nav.showNewSearch(cafm.enums.LocalityTypeData.Building);
        },
        floor: function (e) {

            cafm.prop.nav.showNewSearch(cafm.enums.LocalityTypeData.Floor);
        },
        zone: function (e) {

            cafm.prop.nav.showNewSearch(cafm.enums.LocalityTypeData.Zone);
        },
        space: function (e) {

            cafm.prop.nav.showNewSearch(cafm.enums.LocalityTypeData.Space);
        }
    },
    topLevelSearch: function (e) {

        var st = cafm.web.funcs.getTopSearchText();

        if (!st) return;

        var type;

        if(cafm.nav.isNav(cafm.enums.Navigatable.PropertyBuildingSearch, cafm.enums.Navigatable.PropertyEditBuilding)) {

            type = cafm.enums.getEnumKey(cafm.enums.LocalityTypeData, cafm.enums.LocalityTypeData.Building);
        }
        else if (cafm.nav.isNav(cafm.enums.Navigatable.PropertyFloorSearch, cafm.enums.Navigatable.PropertyEditFloor)) {

            type = cafm.enums.getEnumKey(cafm.enums.LocalityTypeData, cafm.enums.LocalityTypeData.Floor);
        }
        else if (cafm.nav.isNav(cafm.enums.Navigatable.PropertyZoneSearch, cafm.enums.Navigatable.PropertyEditZone)) {

            type = cafm.enums.getEnumKey(cafm.enums.LocalityTypeData, cafm.enums.LocalityTypeData.Zone);
        }
        else if (cafm.nav.isNav(cafm.enums.Navigatable.PropertySpaceSearch, cafm.enums.Navigatable.PropertyEditSpace)) {

            type = cafm.enums.getEnumKey(cafm.enums.LocalityTypeData, cafm.enums.LocalityTypeData.Space);
        }
        else if (cafm.nav.isNav(cafm.enums.Navigatable.PropertyNewSearch, cafm.enums.Navigatable.PropertySavedSearch, cafm.enums.Navigatable.PropertyQuickSearch)) {

            type = cafm.enums.getEnumKey(cafm.enums.PropertySearchType, cafm.filters.getViewModel().SearchType);
        }

        if (type) {

            cafm.router.loadRoute('~/Property#search/{0}/{1}'.format(type, encodeURIComponent(st)));
        }
    },
    handlers: {

        form: function(e) {
            
            var actionEnum = cafm.enums.LocalityFormAction[e.key || e.button['data-key']];

            switch (actionEnum) {

                case cafm.enums.LocalityFormAction.AddNote:

                    cafm.views.openChildActionWindow(e);
                    break;

                case cafm.enums.LocalityFormAction.RemoveSelected:

                    var listWrappers = $('#{0} .k-content.k-state-active .cLvWrap'.format(cafm.res.consts.ElementId_MainForm));
                    listWrappers.each(function (i, el) {

                        var selected = $(el).getSelectedItemUids();
                        if (selected && selected.length) {
                            $('.cTb [data-key="Remove"]', el).click();
                        }
                    });
                    break;

                case cafm.enums.LocalityFormAction.UploadNewDocument:
                case cafm.enums.LocalityFormAction.AddExistingDocument:

                    cafm.views.openActionWindow({
                        url: cafm.url.get(e.item.data('action')),
                        isForm: true,
                        initialText: cafm.res.str.TextPreparingForm,
                        winOptions: {
                            title: $('.k-in', e.item).text(),
                            width: cafm.util.viewPortWidth(60),
                            height: cafm.util.viewPortHeight(80)
                        }
                    });

                    break;

                case cafm.enums.LocalityFormAction.Print:
                       
                    var building = cafm.views.getMainFormViewModel();
                    window.location = cafm.url.api('Building/PrintBuilding?id={0}'.format(building.get('ID')));
                    break;

                case cafm.enums.LocalityFormAction.ReportDataIssue:

                    var locality = cafm.views.getMainFormViewModel(),
                        infoErrorMsg = cafm.util.getReference(cafm.res.consts.ObjectPath_PropertyInfoErrorMsg),
                        mailRecipient = infoErrorMsg.ToAddress,
                        mailSubject = infoErrorMsg.Subject,
                        mailBody = infoErrorMsg.MessageBody;

                    mailSubject = mailSubject.replace('{PropertyDescription}', locality.get('Description'));
                    mailBody = mailBody.replace('{PropertyDescription}', locality.get('Description'));
                    mailBody = mailBody.replace('{PropertyReference}', locality.get('Reference'));
                    mailBody = mailBody.replace('{PropertyLink}', cafm.url.abs(cafm.res.consts.Url_PropertyBuilding.format(locality.get('ID'))));

                    cafm.util.mailTo({
                        ToAddress: mailRecipient,
                        Subject: mailSubject,
                        MessageBody: mailBody
                    });
                    break;
            }
        },
        search: function (e) {

            var key = e.button['data-key'];

            switch (key) {

                case cafm.res.consts.DataKey_Export:

                    cafm.filters.exportResults(e.button['data-value']);
                    break;
            }
        }
    }
}